import { Banner } from '../../../components/Banner/Banner'
import { BTN_TXT } from '../../../constants'
import { useContractDetailsPopup } from '../Providers/ContractDetailsPopupProvider'
import { useContractDetailsContext } from '../Providers/ContractDetailsContextProvider'
import { defaultDateFormat } from '../../../helper/dates'
import { CONTRACT_STATUS } from '../constants'
import {
  ACTIONS,
  contractSubject,
  SUBJECTS
} from 'features/ContractDetails/Abilities'
import { useContractDetailsAbility } from '../Providers/ContractDetailsAbilityProvider'
import { useMemo } from 'react'

const ChangeTerminationDate = () => {
  const { details } = useContractDetailsContext().state
  const { changeTerminationDatePopup } = useContractDetailsPopup()
  const { actions } = changeTerminationDatePopup
  const handleOpenModal = () => {
    actions.open()
  }
  const ability = useContractDetailsAbility()
  const canChangeDate = useMemo(
    () =>
      ability.can(ACTIONS.CANCEL, contractSubject(SUBJECTS.CONTRACT, details)),
    [ability, details]
  )
  return !!details.termination_date &&
    details.status !== CONTRACT_STATUS.TERMINATED ? (
    <Banner
      button={
        canChangeDate
          ? [
              {
                onButtonClick: handleOpenModal,
                buttonText: BTN_TXT.CHANGE_TERMINATION_DATE
              }
            ]
          : undefined
      }
      className="mt-24"
      text={`The contract termination is set for ${defaultDateFormat(
        details.termination_date
      )}.`}
    />
  ) : null
}

export default ChangeTerminationDate
